import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';

// components
import { PdpSharedRequestHold } from '../PdpSharedButtons/PdpSharedRequestHold';
import { lookingSomethingSimilar, startConversationMessage } from '../pdpMessages';
import { PdpSharedContactSellerButton } from '../PdpSharedContactSellerButton/PdpSharedContactSellerButton';

// styles
import styles from './PdpRespSidebarContact.scss';

export const PdpRespSidebarContactComponent = props => {
    const { item, user, itemId, selectedSkuId, userId } = props;
    if (!item) {
        return null;
    }

    return (
        <>
            <div className={styles.questionSold}>{lookingSomethingSimilar}</div>

            <div className={styles.buttons}>
                <div className={styles.requestPrice}>
                    <PdpSharedContactSellerButton
                        fullWidth
                        type="primary"
                        size="medium"
                        className={styles.contactSellerButton}
                        launchOrigin="contact link in pdp - sidebar"
                        user={user}
                        item={item}
                        dataTn="item-actions-request-information"
                        selectedSkuId={selectedSkuId}
                    >
                        {startConversationMessage}
                    </PdpSharedContactSellerButton>
                </div>

                <PdpSharedRequestHold
                    item={item}
                    userId={userId}
                    itemId={itemId}
                    trackingLocation="pdp sidebar"
                />
            </div>
        </>
    );
};

PdpRespSidebarContactComponent.propTypes = {
    userId: PropTypes.string,
    itemId: PropTypes.string.isRequired,
    selectedSkuId: PropTypes.string,
    item: PropTypes.object,
    user: PropTypes.object,
};

export const PdpRespSidebarContact = createFragmentContainer(PdpRespSidebarContactComponent, {
    item: graphql`
        fragment PdpRespSidebarContact_item on Item {
            ...PdpSharedRequestHold_item
            ...PdpSharedContactSellerButton_item
        }
    `,
    user: graphql`
        fragment PdpRespSidebarContact_user on User {
            isVerifiedTrade
            ...PdpSharedContactSellerButton_user
        }
    `,
});
